var select = document.querySelector('#customer-review-slider')

var glide = new Glide('.glide', {
  type: 'carousel',
  perView: 3,
  focusAt: 'center',
  gap: -15,
  peek: { before: 0, after: 0 },
  breakpoints: {
    600: {
      perView: 1,
      peek: { before: 4, after: 4 },
      gap: -25,
    },
    920: {
      perView: 2,
      focusAt: 0,
    },
    950: {
      perView: 3,
    }
  }
})


select.addEventListener('change', function (event) {
  glide.update({
    type: event.target.value
  })
})

glide.mount()